import PackageGreen from "../../components/mainComponents/PackageGreen";
import PackageRed from "../../components/mainComponents/PackageRed";
import classes from "./Package.module.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import svgBack from "../../assets/SVGs/back.svg";
import toast from "react-hot-toast";

function Package() {
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [userAccess, setUserAccess] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        let token = localStorage.getItem("token");

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/v1/user/packages`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const result = await response.json();
        setPackages(result.packages);
        setUserAccess(result.user_all_accsess);
        setIsLoaded(true);
      } catch (error) {
        toast.error("خطا در نمایش پکیج ها");
      }
    };

    if (!isLoaded) {
      loadData();
    }
  }, [isLoaded]);

  return (
    <div className={classes.main}>
      <div className={classes.header}>
        <div className={classes.return} onClick={() => navigate(-1)}>
          <img src={svgBack} className={classes.svg} alt="Back" />
        </div>
      </div>
      <div className={classes.body}>
        <div className={classes.list}>
          <div className={classes.body_header}>وضعیت خرید بسته های آموزشی</div>
          <div className={classes.body_Container}>
            {isLoaded ? (
              packages.map((item) => {
                const [id, title] = item;
                const isAccessible = userAccess.includes(id);
                if (isAccessible) {
                  return (
                    <PackageGreen key={id} package={{ Id: id, Title: title }} />
                  );
                } else {
                  return (
                    <PackageRed key={id} package={{ Id: id, Title: title }} />
                  );
                }
              })
            ) : (
              <div className={classes.loader}></div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Package;
